import { getProductsBySkusV2 } from '@/services/product';
import { useLocale } from 'next-intl';
import useSWR from 'swr';

const useGetProductsBySkus = (skus) => {
  const locale = useLocale();

  const { data, isLoading } = useSWR(
    skus ? skus : null,
    () => getProductsBySkusV2(locale, skus, false),
    {
      revalidateOnFocus: false,
    }
  );

  return [data?.data?.data?.products, isLoading];
};

export default useGetProductsBySkus;
